export const ACTIVATE_ID_CHECK_VERIFICATION =
    'page/ACTIVATE_ID_CHECK_VERIFICATION';
export const ID_CHECK_MAXIMUM_ATTEMPTS = `page/ID_CHECK_MAXIMUM_ATTEMPTS`;

export const ID_CHECK_VERIFICATION_DATA = 'page/ID_CHECK_VERIFICATION_DATA';

export const SEND_VERIFICATION_SMS = 'page/SEND_VERIFICATION_SMS';
export const SEND_VERIFICATION_SMS_PENDING =
    `${SEND_VERIFICATION_SMS} [pending]` as const;
export const SEND_VERIFICATION_SMS_SUCCESS =
    `${SEND_VERIFICATION_SMS} [success]` as const;
export const SEND_VERIFICATION_SMS_FAIL =
    `${SEND_VERIFICATION_SMS} [fail]` as const;

export const TOGGLE_ADD_PHONE_NUMBER = 'page/TOGGLE_ADD_PHONE_NUMBER';
export const ADD_PHONE_NUMBER = 'page/ADD_PHONE_NUMBER';
export const CHANGE_PHONE_NUMBER = 'page/CHANGE_PHONE_NUMBER';
export const PHONE_NUMBER_VALIDATION_ERROR =
    'page/PHONE_NUMBER_VALIDATION_ERROR';
